export type FulfillmentType = 'pickup' | 'delivery' | 'dine_in';

export const FULFILLMENT_OPTIONS: { id: 'pickup' | 'delivery'; label: string; hint: string }[] = [
  { id: 'pickup', label: 'Pick up', hint: 'Collect at the café' },
  { id: 'delivery', label: 'Delivery', hint: 'Delivered to your address' },
];

export function normalizeFulfillmentType(value: unknown): FulfillmentType {
  const raw = String(value || '').toLowerCase().trim();
  if (raw === 'delivery') return 'delivery';
  if (raw === 'dine_in') return 'dine_in';
  return 'pickup';
}
